var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('app-table-design',{staticClass:"users-table",attrs:{"items":_vm.items,"headers":_vm.getHeaders,"loading":_vm.loading,"routes":_vm.routes,"unique-data":_vm.uniqueData,"statuses":_vm.statuses,"total-element-data-table":_vm.total},on:{"get-page-data":_vm.submitData}})
}
var staticRenderFns = []

export { render, staticRenderFns }